import { observable, action, computed, toJS } from 'mobx';
import { ReqInputMsg, Addition, callCmd } from 'lib/reqInputMsg';
import { notification } from 'antd';

export default class UserInfoStore {
  constructor(root) {
    this.root = root;
  }

  //----------------------------------
  /* Mainstore에서 세션만료 처리하기위해 */
  @observable
  _commonStoreInfo = null;

  @computed
  get commonStoreInfo() {
    return this._commonStoreInfo;
  }

  @action
  setCommonStoreInfo = (storeInfo) => {
    this._commonStoreInfo = storeInfo;
  };
  //----------------------------------
  /* 화면 변경 목록, 상세보기, 수정, 추가 */
  @observable
  _viewMode = 'list';

  @computed
  get viewMode() {
    return this._viewMode;
  }

  @action
  onViewMode = (mode) => {
    // list, detail, add, mod
    this._viewMode = mode;
    if (mode === 'add') {
      this._valCondition.checkUserId = false;
      this._detailData = null;
    }
  };
  //----------------------------------
  /* 검색조건 */
  @observable 
  _valCondition = {
    userId: '',
    userNm: '',
    userJobCd: '',
    userUseYn: '',
    ceCd: '',
    ceBranchCd: '',

    pageIdx: 1,
    recordCountPerPage: 10,
    checkUserId: false
  };

  @computed
  get valCondition() {
    return this._valCondition;
  }

  @action
  onChangValue = (dataNm, dataVal) => {
    this._valCondition = {
      ...this._valCondition,
      [dataNm]: dataVal
    };
  };
  //----------------------------------
  /* 상세데이터 */
  @observable
  _detailData = null;

  @computed
  get detailData() {
    return this._detailData;
  }

  @action
  onDetailData = (deta) => {
    if (deta !== null) {
      this._viewMode = 'detail';
    }
    this._detailData = deta;
  };
  //----------------------------------
  @observable
  _userList = [];

  @computed
  get userList() {
    return this._userList;
  }

  @observable
  _pageInfo = null;

  @computed
  get pageInfo() {
    return this._pageInfo;
  }

  @action
  onClear = () => {
    this._viewMode = 'list';
    
    this._userList = [];
    this._pageInfo = null;
    this._detailData = null;
    this._valCondition = {
      userId: '',
      userNm: '',
      userJobCd: '',
      userUseYn: '',
      ceCd: '',
      ceBranchCd: '',

      pageIdx: 1,
      recordCountPerPage: 10,
      checkUserId: false
    };

    // this._jobList = [];
    // this._valConditionJob = {
    //   jobCd: '',
    //   jobNm: '',
    //   jobUseYn: ''
    // };
  };

  //----------------------------------
  @action
  disUserList = async (pageIdx, recordCountPerPage, userUseYn) => {
    if (pageIdx !== undefined && pageIdx !== null && this._valCondition.pageIdx !== pageIdx) {
      this._valCondition.pageIdx = pageIdx;
    }
    if (recordCountPerPage !== undefined && recordCountPerPage !== null && this._valCondition.recordCountPerPage !== recordCountPerPage) {
      this._valCondition.recordCountPerPage = recordCountPerPage;
    }

    if (userUseYn !== undefined && userUseYn !== null && this._valCondition.userUseYn !== userUseYn) {
      this._valCondition.userUseYn = userUseYn;
    }

    let addition = new Addition();
    addition.setCmdName('DIS-USER-LIST');
    addition.setPageYn('Y');
    addition.setPageIndex(this._valCondition.pageIdx);
    addition.setRecordCountPerPage(this._valCondition.recordCountPerPage);
    
    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);
    reqInputMsg.addParam({paraName: 'userId', paraValue: this._valCondition.userId});
    reqInputMsg.addParam({paraName: 'userNm', paraValue: this._valCondition.userNm});
    reqInputMsg.addParam({paraName: 'userJobCd', paraValue: this._valCondition.userJobCd});
    reqInputMsg.addParam({paraName: 'userUseYn', paraValue: this._valCondition.userUseYn});
    reqInputMsg.addParam({paraName: 'userCeCd', paraValue: this._valCondition.ceCd});
    reqInputMsg.addParam({paraName: 'ceBranchCd', paraValue: this._valCondition.ceBranchCd});
    

    return await callCmd(reqInputMsg, 'userInfo')
      .then((res) => {
        if (res.error.code === '0000') {
          // notification.success({placement: 'bottomLeft', message:`조회가 성공하였습니다.`, duration: 2});
          this._userList = res.result;
          this._pageInfo = res.addition;
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.error({placement: 'bottomLeft', message:`리스트를 불러오는데 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
          this._userList = [];
          this._pageInfo = null;
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`조회가 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        this._userList = [];
        this._pageInfo = null;
        console.log('error', error);
      });
  };

  
  //----------------------------------

  @observable
  _excelUploadIng = false;

  @computed
  get excelUploadIng() {
    return this._excelUploadIng;
  }

  @action
  onExcelUploadIng = (boolen) => {
    this._excelUploadIng = boolen;
  }

  @action
  merUserList = async (uploadList) => {
    if (uploadList.length <= 0) {
      notification.error({placement: 'bottomLeft', message:`데이터가 없습니다. 파일을 확인하세요..`, duration: 2});
      return;
    }

    this._excelUploadIng = true;
    let addition = new Addition();
    addition.setCmdName('MER-USER-LIST');

    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);
    reqInputMsg.addParam({paraName: 'uploadList', paraValue: uploadList});
    
    return await callCmd(reqInputMsg, 'userInfo')
      .then((res) => {
        if (res.error.code === '0000') {
          if (res.result[0].resultMsg) {
            notification.success({placement: 'bottomLeft', message:`등록이 성공하였습니다.`, duration: 2});
            this._excelUploadIng = false;
            this._viewMode = 'list';
            this.disUserList();
          } else {
            notification.success({placement: 'bottomLeft', message:`등록이 실패하였습니다.`, duration: 2});
            this._excelUploadIng = false;
          }
        } else if (res.error.code === '0003') {
          this._excelUploadIng = false;
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.success({placement: 'bottomLeft', message:`등록이 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
          this._excelUploadIng = false;
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`등록이 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        this._excelUploadIng = false;
        console.log('error', error);
      });

  };

  @action
  addUserInfo = async (data) => {
    // data를 name value로 수정
    let paramData = [];
    Object.keys(data).map((key)=>{ return (
        paramData.push({
          paraName: key, paraValue: data[key]
        })
    )});

    // console.log(paramData);

    let addition = new Addition();
    addition.setCmdName('ADD-USER-INFO');

    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);
    reqInputMsg.setParamList(paramData);
    
    return await callCmd(reqInputMsg, 'userInfo')
      .then((res) => {
        if (res.error.code === '0000') {
          if (res.result[0].resultMsg) {
            notification.success({placement: 'bottomLeft', message:`등록이 성공하였습니다.`, duration: 2});
            this._viewMode = 'list';
            this.disUserList();
          } else {
            notification.success({placement: 'bottomLeft', message:`등록이 실패하였습니다.`, duration: 2});
          }
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.success({placement: 'bottomLeft', message:`등록이 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`등록이 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        console.log('error', error);
      });
  };

  @action
  modUserInfo = async (data) => {
    // data를 name value로 수정
    let paramData = [];
    Object.keys(data).map((key)=>{return (
      paramData.push({
        paraName: key, paraValue: data[key]
      })
    )});

    //console.log('paramData', paramData);

    let addition = new Addition();
    addition.setCmdName('MOD-USER-INFO');

    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);
    reqInputMsg.setParamList(paramData);
    
    return await callCmd(reqInputMsg, 'userInfo')
      .then((res) => {
        if (res.error.code === '0000') {
          if (res.result[0].resultMsg) {
            notification.success({placement: 'bottomLeft', message:`수정이 성공하였습니다.`, duration: 2});
            this._viewMode = 'detail';
            this._detailData = data;
            this.disUserList();
          } else {
            notification.success({placement: 'bottomLeft', message:`수정이 실패하였습니다.`, duration: 2});
          }
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.success({placement: 'bottomLeft', message:`수정이 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`수정이 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        console.log('error', error);
      });

  };

  @action
  useUserYn = async (userId, userUseYn) => {
    let addition = new Addition();
    addition.setCmdName('USE-USER-YN');

    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);
    reqInputMsg.addParam({paraName: 'userId', paraValue: userId});
    reqInputMsg.addParam({paraName: 'userUseYn', paraValue: userUseYn === 'Y' ? 'N' : 'Y'});
    
    return await callCmd(reqInputMsg, 'userInfo')
      .then((res) => {
        if (res.error.code === '0000') {
          if (res.result[0].resultMsg) {
            notification.success({placement: 'bottomLeft', message:`수정에 성공하였습니다.`, duration: 2});
            this._detailData = null;
            this._viewMode = 'list';
            this.disUserList();
          } else {
            notification.success({placement: 'bottomLeft', message:`수정에 실패하였습니다.`, duration: 2});
          }
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.success({placement: 'bottomLeft', message:`수정에 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`수정에 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        console.log('error', error);
      });
  };

  @action
  disUserCheck = async (chkData) => {
    let addition = new Addition();
    addition.setCmdName('DIS-USER-CHECK');
    
    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);
    reqInputMsg.addParam({paraName: 'userId', paraValue: chkData});
    
    return await callCmd(reqInputMsg, 'userInfo')
      .then((res) => {
        if (res.error.code === '0000') {
          if (res.result.length > 0) {
            notification.error({placement: 'bottomLeft', message: `중복된 사번이 있습니다.`, duration: 2});
          } else {
            notification.success({placement: 'bottomLeft', message: `추가 가능한 사번 입니다.`, duration: 2});
            this._valCondition.checkUserId = true;
          }
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.success({placement: 'bottomLeft', message:`중복된체크가 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`중복된체크가 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        console.log('error', error);
      });
  };
  //----------------------------------
  /* 직무관리 */
  @observable
  _jobList = [];

  @computed
  get jobList() {
    return this._jobList;
  }
  //----------------------------------
  /* 검색조건 */
  @observable 
  _valConditionJob = {
    jobCd: '',
    jobNm: '',
    jobUseYn: ''
  };

  @computed
  get valConditionJob() {
    return this._valConditionJob;
  }

  @action
  onChangValueJob = (dataNm, dataVal) => {
    this._valConditionJob = {
      ...this._valConditionJob,
      [dataNm]: dataVal
    };
  };
  //---------------------------------
  
  @action
  disJobList = async (jobCd, jobNm, jobUseYn) => {
    if (jobCd !== undefined && jobCd !== null && this._valConditionJob.jobCd !== jobCd) {
      this._valConditionJob.jobCd = jobCd;
    }
    if (jobNm !== undefined && jobNm !== null && this._valConditionJob.jobNm !== jobNm) {
      this._valConditionJob.jobNm = jobNm;
    }

    if (jobUseYn !== undefined && jobUseYn !== null && this._valConditionJob.jobUseYn !== jobUseYn) {
      this._valConditionJob.jobUseYn = jobUseYn;
    }
    
    let addition = new Addition();
    addition.setCmdName('DIS-JOB-LIST');
    
    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);
    reqInputMsg.addParam({paraName: 'jobCd', paraValue: this._valConditionJob.jobCd});
    reqInputMsg.addParam({paraName: 'jobNm', paraValue: this._valConditionJob.jobNm});
    reqInputMsg.addParam({paraName: 'jobUseYn', paraValue: this._valConditionJob.jobUseYn});
    
    return await callCmd(reqInputMsg, 'userInfo')
      .then((res) => {
        if (res.error.code === '0000') {
          // notification.success({placement: 'bottomLeft', message:`조회가 성공하였습니다.`, duration: 2});
          this._jobList = res.result;
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.error({placement: 'bottomLeft', message:`리스트를 불러오는데 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
          this._jobList = [];
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`조회가 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        this._jobList = [];
        console.log('error', error);
      });
  };

  @action
  merJobList = async (uploadList) => {
    let addition = new Addition();
    addition.setCmdName('MER-JOB-LIST');

    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);
    reqInputMsg.addParam({paraName: 'uploadList', paraValue: toJS(uploadList)});
    return await callCmd(reqInputMsg, 'userInfo')
      .then((res) => {
        if (res.error.code === '0000') {
          if (res.result[0].resultMsg) {
            notification.success({placement: 'bottomLeft', message:`저장이 성공하였습니다.`, duration: 2});
            this.disJobList();
          } else {
            notification.success({placement: 'bottomLeft', message:`저장이 실패하였습니다.`, duration: 2});
          }
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.success({placement: 'bottomLeft', message:`저장이 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`저장이 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        console.log('error', error);
      });

  };
}
  
